<template>
    <header :class="$style.wrapper">
        <div :class="$style.inner">
            <div :class="$style.row">
                <div :class="$style.leftColumn">
                    <a target="_blank" href="https://www.beapplied.com/" :class="$style.logoLink">
                        <img :class="$style.logo" src="@/assets/applied_logo_master_white.svg" alt="Applied logo" />
                    </a>
                    <div :class="$style.headerTitle"><h2>The job board</h2></div>
                </div>
                <div :class="$style.ratingRow" aria-hidden="true">
                    <div :class="$style.candidateRatingContainer">
                        <div :class="$style.candidateRatingHeader">Average candidate rating</div>
                        <div :class="$style.candidateRatingGraphicHeader">
                        <img src="@/assets/nine-out-of-ten-stars.svg" aria-hidden="true" />
                        <div :class="$style.ratingNumbers">9/10</div>
                        </div>
                    </div>
                    </div>           
                 </div>
        </div>
    </header>
</template>

<script>
export default {
    name: 'Header',
    computed: {
        showMobileVersion() {
            if (window.innerWidth > 870) {
                return false
            } else {
                return true
            }
        }
    },
}
</script>

<style module src="./Header.css" />